<template>
    <div class="carousel">

        <div>大咖推荐</div>
        <el-card style="margin-top: 20px;" shadow="never">
            <el-switch v-model="is_show_recommend" active-text="开启" inactive-text="关闭" @change="changnew">
            </el-switch>
        </el-card>
    </div>
</template>
  
<script>

import {
    updateHomepage,
} from "@/api/homeset";
export default {
    name: "dk",
    props: {
        homepage_id: Number,
        is_show_recommend: Boolean,
    },
    data() {
        return {
            imageId: "",

        };
    },
    watch: {
        // news_is_show() {
        //     this.is_show_recommend = this.news_is_show
        // },

    },
    methods: {
        changnew() {
            updateHomepage({
                id: this.homepage_id,
                is_show_recommend: this.is_show_recommend === false ? '0' : '1'
            }).then((res) => {
                if (res.is_update) {
                    this.$message.success("保存成功！");
                }
            })

        },

    },
};
</script>
  
<style scoped lang="scss">
.carousel {
    height: 100%;
    background-color: #fff;

    .table-style {
        margin-top: 20px;
        padding-bottom: 20px;
    }
}
</style>
  